import log4javascript, {NullLayout, Level} from 'log4javascript/js/log4javascript_production.js';

function BrowserConsoleAppender() {}

BrowserConsoleAppender.prototype = new log4javascript.Appender();
BrowserConsoleAppender.prototype.layout = new NullLayout();
BrowserConsoleAppender.prototype.threshold = Level.DEBUG;

BrowserConsoleAppender.prototype.append = function(loggingEvent) {
  var appender = this;

  var getFormattedMessage = function(concatenate) {
    var formattedMessage = appender.getLayout().formatWithException(loggingEvent);
    return (typeof formattedMessage == "string") ?
      (concatenate ? formattedMessage : [formattedMessage]) :
      (concatenate ? formattedMessage.join(" ") : formattedMessage);
  };

  var console = window.console;

  if (console && console.log) {
    // Log to Firebug or the browser console using specific logging
    // methods or revert to console.log otherwise
    var consoleMethodName;

    if (console.debug && Level.DEBUG.isGreaterOrEqual(loggingEvent.level)) {
      consoleMethodName = "debug";
    } else if (console.info && Level.INFO.equals(loggingEvent.level)) {
      consoleMethodName = "info";
    } else if (console.warn && Level.WARN.equals(loggingEvent.level)) {
      consoleMethodName = "warn";
    } else if (console.error && loggingEvent.level.isGreaterOrEqual(Level.ERROR)) {
      consoleMethodName = "error";
    } else {
      consoleMethodName = "log";
    }

    if (typeof console[consoleMethodName].apply == "function") {
      console[consoleMethodName].apply(console, getFormattedMessage(false));
    } else {
      console[consoleMethodName]( getFormattedMessage(true) );
    }
  } else if ((typeof opera != "undefined") && opera.postError) { // Opera
    opera.postError( getFormattedMessage(true) );
  }
};

BrowserConsoleAppender.prototype.group = function(name) {
  if (window.console && window.console.group) {
    window.console.group(name);
  }
};

BrowserConsoleAppender.prototype.groupEnd = function() {
  if (window.console && window.console.groupEnd) {
    window.console.groupEnd();
  }
};

BrowserConsoleAppender.prototype.toString = function() {
  return "BrowserConsoleAppender";
};

export default BrowserConsoleAppender;
